import { render, staticRenderFns } from "./ReferenceModal.vue?vue&type=template&id=37f0d414&scoped=true"
import script from "./ReferenceModal.vue?vue&type=script&lang=js"
export * from "./ReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./ReferenceModal.vue?vue&type=style&index=0&id=37f0d414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0d414",
  null
  
)

export default component.exports